/**
 * @file 私有化应用版本号，假如配置，将覆盖g_apps中的版本号
 */
const apps = {
  'isipfe/xiaomi-common': '2.x',
  'isipfe/robot': '0.1.71',
  'isipfe/qa_evaluation': '0.0.1',
  'alime-ylab/auto-dialog-ui': '0.0.2',
  'isipfe/kc_lta': '0.0.2',
  'isipfe/operation_tool': '0.0.2',
  'isipfe/discovery': '0.1.0',
  'isipfe/lib': '0.0.1',
  'isipfe/knowledge': '0.0.1',
  'isipfe/slate_editor': '0.0.1',
  'isipfe/tenant_management': '0.0.2',
  'isipfe/user_management': '0.0.2',
  'isipfe/business_management': '0.0.2',
  'alimefe/sys_config': '0.0.1',
  'alimefe/cab_ops': '0.0.1',
};

if (window.g_config.productMode.toLowerCase().indexOf('private') >= 0) {
  const output = [];
  Object.keys(apps).forEach((name) => {
    const version = apps[name];
    output.push(`${name}:${version}`);
    window.g_apps[name] = Object.assign({}, window.g_apps[name], {
      name,
      version,
      preVersion: version,
    });
  });
  console.log(`私有化使用版本号:${output.join(',')}`);
}



// WEBPACK FOOTER //
// ./src/config/private-version.js